module.exports = __webpack_public_path__ + "img/JET-Sans-digital.b32a4e2b.svg";